<div>
  <div class="p-section">
    <div class="table-responsive">
      <app-search-license-plate-result *ngIf="searchResultType === 0" [data]="data"></app-search-license-plate-result>
      <app-search-identity-card-result *ngIf="searchResultType === 1" [data]="data"></app-search-identity-card-result>
    </div>
  </div>
</div>
